import ForbiddenAccess from 'components/Error/403';

const Screen403 = () => {
  return <ForbiddenAccess />;
};

export default Screen403;
